export const API_TYPE = Object.freeze({
  DG: "domain-groups",
  DOMAINS: "domains",
  USERS: "users",
  MSPS: "msps",
});

export default {};
